import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectCeilingHeightFilter } from 'shared/selectors/advancedFilters';

export const CeilingHeightContainer: FC = () => {
  const { label, value, options } = useSelector(selectCeilingHeightFilter);

  const onChange = useFilterChangeCallback();

  const handleCeilingHeightChange = useCallback(
    (newValue: number | null) => {
      onChange({ action: 'setMinCeilingHeight', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleCeilingHeightChange} />
    </AdvancedFilterRow>
  );
};
